export default class UsersCtrl {

	constructor($rootScope, $scope, GeneralSettingsSrv, $mdDialog, $interval, $uiGridConstants, i18nService, $state, $cookies, Validations, GlobalConfig) {
		const usrVM = this
		const user = JSON.parse($cookies.get('currentUser'))
		const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

		i18nService.setCurrentLang('es')
		usrVM.currentPage = 0
		usrVM.roles = []
		usrVM.rolescomitee = { id_code: '' }
		usrVM.rolesGridcomitee = []
		usrVM.rolesGrid = []
		usrVM.unitAdmin = GlobalConfig.userRolesIds.unitAdmin
		usrVM.generalConsultant = GlobalConfig.userRolesIds.generalConsultant
		usrVM.workplanConsultant = GlobalConfig.userRolesIds.workplanConsultant
		usrVM.gerencialConsultant = GlobalConfig.userRolesIds.gerencialConsultant
		// usrVM.roles = {}
		usrVM.confirmDisableUser = confirmDisableUser
		usrVM.roleId = currentRoleId
		usrVM.confirmDisableComite = confirmDisableComite
		usrVM.intialize = intialize

		function intialize() {
			let header = { }

			if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId) || Validations.isCommitteeAdmin(currentRoleId)) {
				header.userId = user.id
				header.rolId = currentRoleId
			}
 
			GeneralSettingsSrv.getUsers.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					usrVM.usersGrid.data = dataReturn.data
					usrVM.usersComiteeGrid.data = dataReturn.commite
				} else {
					console.log('communications failure with server')
				}
			}).then(() => {
				GeneralSettingsSrv.getRoles.get().$promise.then((dataReturn) => {
					if (dataReturn.status == true) {
						for (var i in dataReturn.data) {
							if (!angular.equals(dataReturn.data[i].ds_name, 'Comité')) {
								usrVM.roles = []
							}
						}
						for (var i in dataReturn.data) {
							if (angular.equals(dataReturn.data[i].ds_name, 'Comité')) {
								usrVM.rolescomitee.id_code = dataReturn.data[i].id_code
							} else {
								if (angular.equals(currentRoleId, usrVM.unitAdmin)) {
									if (angular.equals(dataReturn.data[i].id_code, usrVM.workplanConsultant) || 
                  angular.equals(dataReturn.data[i].id_code, usrVM.gerencialConsultant)) {
										usrVM.roles.push(dataReturn.data[i])
									}                 
								} else {
									usrVM.roles.push(dataReturn.data[i])
								}
							}
						}
					} else {
						console.log('Comunications failure with the server')
					}
				})
			})
		}

		usrVM.restructureDate = (user) => {
			let day = user.comiteeEndDate.substring(8, 10)
			let month = user.comiteeEndDate.substring(5, 7)
			let year = user.comiteeEndDate.substring(0, 4)

			return day + '/' + month + '/' + year
		}

		usrVM.highlightFilteredHeader = (row, rowRenderIndex, col, colRenderIndex) => {
			if (col.filters[0].term) {
				return 'header-filtered'
			} else {
				return ''
			}
		}

		usrVM.usersGrid = {
			enableFiltering: true,
			columnDefs     : [
				{
					name            : 'Nombre',
					displayName     : 'Nombre',
					field           : 'userName',
					width           : '20%',
					headerCellClass : usrVM.highlightFilteredHeader,
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Unidad académica',
					displayName     : 'Unidad académica',
					field           : 'academicName',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Tipo',
					displayName     : 'Tipo',
					field           : 'userRole',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Fecha de vencimiento',
					displayName     : 'Fecha de vencimiento',
					field           : 'comiteeEndDate',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellFilter      : "date: 'dd/MM/yyyy': 'UTC'",
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Acciones',
					displayName     : 'Acciones',
					field           : '',
					width           : '20%',
					enableGridMenu  : false,
					enableFiltering : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'column-right text-xs',
					headerCellClass : 'column-center font-normal text-xs',
					cellTemplate    : require('./userActionsCell.html'),
				},
			],
			onRegisterApi: (gridApi) => {
				usrVM.gridApi = gridApi
				usrVM.gridApi.grid.registerRowsProcessor(usrVM.singleFilter, 200)
				$interval(() => {
					usrVM.gridApi.core.handleWindowResize()
				}, 500, 10)
			},
		}

		usrVM.usersComiteeGrid = {
			enableFiltering: true,
			columnDefs     : [
				{
					name            : 'Nombre del comité',
					displayName     : 'Nombre del comité',
					field           : 'comiteeName',
					width           : '40%',
					headerCellClass : usrVM.highlightFilteredHeader,
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Tipo',
					displayName     : 'Tipo',
					field           : 'userRole',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Fecha de vencimiento',
					displayName     : 'Fecha de vencimiento',
					field           : 'comiteeEndDate',
					width           : '20%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellFilter      : "date: 'dd/MM/yyyy': 'UTC'",
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Acciones',
					displayName     : 'Acciones',
					field           : '',
					width           : '20%',
					enableGridMenu  : false,
					enableFiltering : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'column-right text-xs',
					headerCellClass : 'column-center font-normal text-xs',
					cellTemplate    : require('./comiteActionsCell.html'),
				},
			]
			,
			onRegisterApi: (gridApi) => {
				usrVM.gridApi1 = gridApi
				usrVM.gridApi1.grid.registerRowsProcessor(usrVM.singleFiltercomitee, 200)
				$interval(() => {
					usrVM.gridApi1.core.handleWindowResize()
				}, 500, 10)
			},
		}

		usrVM.filtercomitee = () => {
			usrVM.gridApi1.grid.refresh()
		}

		usrVM.singleFiltercomitee = function(renderableRows) {
			var matcher = new RegExp(usrVM.usersFiltercomitee, 'i')

			renderableRows.forEach(function(row) {
				var match = false;

				[ 'comiteeName', 'comiteeEndDate' ].forEach(function(field) {
					if (row.entity[field].match(matcher)) {
						match = true
					}
				})

				if (!match) {
					row.visible = false
				}
			})

			return renderableRows
		}

		usrVM.filter = () => {
			usrVM.gridApi.grid.refresh()
		}

  	usrVM.singleFilter = function(renderableRows) {
  		var matcher = new RegExp(usrVM.usersFilter, 'i')

  		renderableRows.forEach(function(row) {
  			var match = false;

  			[ 'userName', 'academicName', 'userRole' ].forEach(function(field) {
  				if (row.entity[field].match(matcher)) {
  					match = true
  				}
  			})

  			if (!match) {
  				row.visible = false
  			}
  		})

  		return renderableRows
  	}

		usrVM.router = (route) => {
			if (route.id_code !== 4) {
				$state.go('generalSettings.createUsers', { roleId: usrVM.selectedRole.id_code })
			} else {
				$state.go('generalSettings.createCommittee')
			}
		}

		function disableCommittee(params, row, dialog) {
			return GeneralSettingsSrv.disableCommittee.post(params).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					removeRow(row)
					dialog.hide()
					$rootScope.$emit('$disablePermit')
				}
			}).catch((error) => {
				console.log('communications failure with server')
			})
		}

		function disablePermit(params, row, dialog) {
			return GeneralSettingsSrv.disablePermit.post(params).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					removeRow(row)
					dialog.hide()
					$rootScope.$emit('$disablePermit')
				}
			}).catch((error) => {
				console.log('communications failure with server')
			})
		}

		$rootScope.$on('$disablePermit', function(event, data) {
			console.log('disablePermit')
			// $state.reload()

			intialize()
		})

		function removeRow(entity) {
			var index = usrVM.usersGrid.data.indexOf(entity)

			usrVM.usersGrid.data.splice(index, 1)
		}

		function eliminatePermit(entity, dialog) {
			if (entity.userRoleId === 4) {
				let params = {
					userId   : entity.userId,
					comiteeId: entity.comiteeId,
					roleId   : entity.userRoleId,
				}

				disableCommittee(params, entity, dialog)
			} else {
				let params = {
					userId        : entity.userId,
					roleId        : entity.userRoleId,
					academicUnitId: entity.academicId,
				}

				disablePermit(params, entity, dialog)
			}
		}

		function confirmDisableUser (userEntity) {
			let user = userEntity

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.user = user
					$scope.userName = user.userName
					$scope.close = function() {
						$mdDialog.hide()
					}
					$scope.disableUser = function(entity) {
						eliminatePermit(entity, $mdDialog)
					}
				} ],
				template           : require('./confirmDisableUserModal.html'),
				clickOutsideToClose: false,
			})
		}

		function confirmDisableComite (userEntity) {
			let user = userEntity

			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function ($scope, $mdDialog) {
					$scope.user = user
					$scope.comiteeName = user.comiteeName
					$scope.close = function() {
						$mdDialog.hide()
					}
					$scope.disableUser = function(entity) {
						eliminatePermit(entity, $mdDialog)
					}
				} ],
				template           : require('./confirmDisableComiteModal.html'),
				clickOutsideToClose: false,
			})
		}

		intialize()
	}

}

UsersCtrl.$inject = [ '$rootScope', '$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', '$cookies', 'Validations', 'GlobalConfig' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/users/list/usersCtrl.js